<script setup>
/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits, ref } from 'vue';

/*==================================================================*/
/*================== UTIL IMPORTS ==================================*/
/*==================================================================*/

import UtilNumber from '@/utils/UtilNumber';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    label: {
        type: String,
        default: ''
    },
    value: {
        type: [String, Number],
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    },
    min: {
        type: Number,
        default: 0
    },
    max: {
        type: Number,
        default: Number.MAX_SAFE_INTEGER
    },
    step: {
        type: Number,
        default: 1
    }
});

/*==================================================================*/
/*================== EMITS =========================================*/
/*==================================================================*/

const emits = defineEmits([
    'input',
]);

const textFieldRef = ref(null);

/*==================================================================*/
/*================== MÉTODOS =======================================*/
/*==================================================================*/

const onInput = (value = 0) => {

    // Limita o Valor para estar sempre entre o min e max.
    value = UtilNumber.clamp(value,props.min,props.max);

    // Seta o Lazy Value para ser identico ao valor campo.
    textFieldRef.value.lazyValue = value;

    // Emite o evento.
    emits('input', value);

}

</script>

<template>

    <v-text-field
        ref="textFieldRef"
        class="c-text-field"
        :label="props.label"
        :value="props.value"
        :disabled="props.disabled"
        :min="props.min"
        :max="props.max"
        :step="props.step"
        type="number"
        prepend-icon="mdi-counter"
        outlined
        hide-details
        v-bind="$attrs"
        @input="onInput($event)"
    ></v-text-field>

</template>

<style scoped>

.c-text-field {
    padding: 2px;
}

.c-text-field >>> .v-input__slot {
    min-height: 48px;
}

</style>
